<script>
    /*
    	BaseReviewListItem.svelte

        Semi-reusable - add custom extended fields if needed.



    {
        "id": 2,
        "reviewType": "update",
        "dateAssigned": "03/02/2022",
        "dateSubmitted": "Thu May 12 09:53:10 CDT 2022",
        "taskId": "1",
        "taskSummary": "update task for Iowa counties",
        "submitterId": 1,
        "submitterName": "Jack Attack",

        "leftService": {
            "id": 34,
            "createdAt": "0001-01-01T00:00:00Z",
            "updatedAt": "0001-01-01T00:00:00Z",
            "serviceName": "Sarah Kathryn Tighe MD",
            "description": "",
            "mainWebsite": null,
            "source": "-",
            "lat": null,
            "lon": null,
            "locationPrecision": null,
            "eligibility": null,
            "operatingHours": "-",
            "addressLine1": "200 Hawkins Dr  Iowa",
            "postalCode": "52242",
            "county": "-",
            "city": "City",
            "state": "IA",
            "country": null,
            "mainPhone": "3193561616",
            "mainEmail": "-",
            "coverageCounties": null,
            "coveragePostalCodes": "-",
            "mainFax": null,
            "mainFacebook": null,
            "mainTwitter": null,
            "googleBusinessLink": "-",
            "supportedInsurance": null,
            "reviewed": 0,
            "exclusiveRequirements": null,
            "taxonomies": {
                "tcare-taxonomy-1": [
                "neurologists"
                ]
            },
        },

        "rightService": {
            "id": null,
            "createdAt": "0001-01-01T00:00:00Z",
            "updatedAt": "0001-01-01T00:00:00Z",
            "serviceName": "Sarah Kathryn Tighe MD",
            "description": "",
            "mainWebsite": null,
            "source": "-",
            "lat": null,
            "lon": null,
            "locationPrecision": null,
            "eligibility": null,
            "operatingHours": "-",
            "addressLine1": "200 Hawkins Dr  Iowa",
            "postalCode": "52242",
            "county": "-",
            "city": "City",
            "state": "IA",
            "country": null,
            "mainPhone": "3193561616",
            "mainEmail": "-",
            "coverageCounties": null,
            "coveragePostalCodes": "-",
            "mainFax": null,
            "mainFacebook": null,
            "mainTwitter": null,
            "googleBusinessLink": "-",
            "supportedInsurance": null,
            "reviewed": 0,
            "exclusiveRequirements": null,
            "taxonomies": {
                "tcare-taxonomy-1": [
                "neurologists"
                ]
            },
        }
    }


    NEW JSON - 8/23

    {
        createdAt: "2022-08-23T13:13:35.566064Z"
        createdServiceID: null
        dateAssigned: null
        dateSubmitted: "2022-08-23T13:13:21.812997Z"
        date_accepted: null
        date_rejected: null
        finalService: null
        isSelected: false
        id: "ed8c1906-92cf-43cc-bb6b-464d54bfab93"

        flags: Array(2)
            0: {id: 1, createdAt: '0001-01-01T00:00:00Z', updatedAt: '0001-01-01T00:00:00Z', flagName: 'duplicate-intake', description: 'duplicate detected by intake func'}
            1: {id: 5, createdAt: '0001-01-01T00:00:00Z', updatedAt: '0001-01-01T00:00:00Z', flagName: 'main-website-error-intake', description: 'intake func failed to establish connection with main website'}


        leftServiceIds: Array(2)
            0: 99001
            1: 11011

        leftServices: Array(2)
            0: {id: 11011, createdAt: '2022-08-02T21:04:07.957858Z', updatedAt: '2022-08-02T21:04:07.957858Z', serviceName: 'Heart of St. Louis Adult Day Health Center', description: '-', …}
            1: {id: 99001, createdAt: '2022-08-02T21:31:32.093111Z', updatedAt: '2022-08-02T21:31:32.093111Z', serviceName: 'Heart of St. Louis Adult Day Health Center', description: '-', …}

        reviewSubType: "human"
        reviewType: "update"
        reviewerId: null
        rightService:
        additionalInformation: []
        addressLine1: "2200 Washington Ave."
        availability: null
        city: "St. Louis"
        costFreeText: null
        country: null
        county: "-"
        coverageAreas: []
        coverageCounties: null
        coverageGranularity: null
        coveragePostalCodes: null
        createdAt: "2022-08-02T21:04:07.957858Z"
        description: "-"
        eligibility: null
        exclusiveRequirements: null
        googleBusinessLink: null
        googleNumberRatings: null
        googleRating: null
        googleTestimonials: null
        id: null
        insuranceAccepted: []
        lastValidated: null
        lat: 38.6332
        locationPrecision: "street"
        lon: -90.2164
        mainEmail: "-"
        mainFacebook: null
        mainFax: null
        mainPhone: "3149321449"
        mainTwitter: null
        mainWebsite: null
        minerNotes: []
        necessaryDocuments: []
        necessaryMaterials: []
        nextSteps: null
        operatingHours: null
        otherSocialMedia: null
        postalCode: "63103-1522"
        reviewed: 1
        serviceName: "Heart of St. Louis Adult Day Health Center"
        source: "andy.knoll@tcare.ai"
        state: "MO"
        supportedInsurance: null
        supportedLanguages: []
        taxonomies: {demographics: Array(0), open-eligibility-2022: Array(1), tcare-taxonomy-1: Array(2)}
        updatedAt: "2022-08-02T21:04:07.957858Z"
        status: "pending"
        submitterId: "222cb581-c23c-4fd8-8bdf-44c32ca39545"
        submitterName: "Andy Knoll"
        taskId: ""
        taskSummary: null
        updatedAt: "2022-08-23T13:13:35.566066Z"
    }

    */

    import { onMount } from 'svelte';
    import { formatShortDate } from '../../common/utils.js';

    // TCARE components

    // SMUI components
    import Checkbox from '@smui/checkbox';
	import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiInformationOutline } from '@mdi/js';

    const EVEN_ROW_STYLE = 'background-color: #F1EFF1';
    const ODD_ROW_STYLE  = 'background-color: #F9F7FA';     // or #F6F4F6?
    const SEL_ROW_STYLE  = 'background-color: #FFF3F5';

    // Review fields - move to consts.js!
    const TASK_ID = 'taskId';
    const TASK_SUMMARY = 'taskSummary';
    const RIGHT_SERVICE = 'rightService';

    export let item;                        // a Service index in this case
    export let index;                       // for odd-even row colors
    export let onCheckboxClick;             // handled in the parent List
    export let isCheckbox;                  // show or hide the item's Checkbox
    export let onEditReview;                // handled in the parent ReviewPage

    $: listItemStyle = getListItemStyle(item);

    onMount(() => {
        // console.log('BaseReviewListItem onMount');
        // console.log('item:');
        // console.log(item);
        formatReviewFields();
    })

    const formatReviewFields = () => {
        // check for Review summary or Service name
        let summary = '';
        if (!item[TASK_SUMMARY] || item[TASK_SUMMARY] == '' ) {
            if (item[RIGHT_SERVICE]) {
                item[TASK_SUMMARY] = item[RIGHT_SERVICE].serviceName
            } else {
                item[TASK_SUMMARY] = 'no review summary or service name'
            }
        }
    }

    // odd-even row colors
    const getListItemStyle = () => {
        let style = ODD_ROW_STYLE;
        if (index % 2 == 0) style = EVEN_ROW_STYLE;
        if (item.isSelected) style = SEL_ROW_STYLE;
        return style;
    }

    const _onCheckboxClick = (e) => {
        e.stopPropagation();
        onCheckboxClick(item);          // call provided handler on List (onItemCheckboxClick)
    }

</script>

<style>
    .review-list-item-wrapper {
        scroll-margin-top: 55px;            /* 55 header + 0 menu */
        width: 100%;
        margin-bottom: 5px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        border-radius: 5px;
        overflow: hidden;
    }

    .review-list-item {
        width: 95%;
        opacity: 1;
        padding: 15px 0px;
        font-size: 15px;
        font-weight: normal;
        color: var(--tcare-primary);

        display: flex;
        align-items: center;
        justify-content: flex-start;

        border-radius: 5px;
        border: 1px solid var(--tcare-white);
    }

    .review-list-item:hover {
        border: 1px solid var(--tcare-purple);
    }

    /*
    .review-list-item > * {
        border: 1px solid red;
    }
    */

    .spacer {
        width: 1%;
    }

    /* checkbox */
    .check-box {
        width:  5%; 
        margin-top: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }   

    :global(.check-box .mdc-checkbox) {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        /* border: 1px solid red; */
    }

    /* convert checkboxes to circles */
    :global(.check-box .mdc-checkbox__background) {
        width: 20px;
        height: 20px;
        border-radius: 50%;
    }



    /* info icon */
    .cell-0 { 
        width: 3%; 
    }

    :global(.cell-0 svg) { 
        width: 24px;
        height: 24px;
        fill: var(--tcare-primary);
        outline: none;
     }

    /* summary/name */
    .cell-1 { width: 33%; text-align: left }

    /* flags */
    .cell-2 { width: 10%; text-align: right }

    /* taskId */
    .cell-3 { width: 10%; text-align: right }

    /* status */
    .cell-4 { width: 12%; text-align: right }

    /* dateSubmitted */
    .cell-5 { width: 11%; text-align: right }

    /* submitter */
    .cell-6 { width: 17%; text-align: right }
    

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<!-- SHOULD BE USING FIELD NAME CONSTANTS HERE -->
<div class="review-list-item-wrapper">

    <div class="check-box">
        {#if isCheckbox}
            <Checkbox on:click={_onCheckboxClick} checked={item.isSelected}/>
        {/if}
    </div>

    <div class="review-list-item" style={listItemStyle}>
        <div class="spacer"></div>

        <div class="cell-0 flex-center">
            <Icon component={Svg} viewBox="0 0 24 24" on:click={() => onEditReview(item)} >
                <path d={mdiInformationOutline} />
            </Icon>
        </div>

        <div class="spacer"></div>

        <div class="cell-1 ellipsis">{item[TASK_SUMMARY]}</div>

        <div class="cell-2">{item['flags'] ? item['flags'].length : 0}</div>

        <div class="cell-3">{item[TASK_ID]}</div>

        <div class="cell-4">{item['status']}</div>

        <div class="cell-5">{formatShortDate(item['dateSubmitted'])}</div>

        <div class="cell-6">{item['submitterName']}</div>
    </div>
</div>